module.exports = __webpack_public_path__ + "img/r-1-actbtn.648248cf.png";